/* MUI */
import { Grid } from '@mui/material';

/*  Shared  */
import {
    DataAPIVisualsPercentage,
    DataAPIVisualsPieChart,
    DataAPIVisualsSum,
    DataAPIVisualsTotal
} from 'application/Shared/Components/DataAPIVisualsCard';
import { useManagedTableV2Context } from 'application/Shared/Components/Table';
import { ClientLink } from 'application/Shared/types/clientLink';
import { ProviderType } from 'application/Shared/types/tenantProvider';

/*  React  */
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const findIdentityManagement = ({
    gws,
    entra
}: {
    gws: boolean;
    entra: boolean;
}) => {
    if (gws) {
        return 'gws';
    }
    if (entra) {
        return 'entra';
    }
    return 'noIdentityManagement';
};

export const PartnerClientsStatCards = () => {
    const { t } = useTranslation();
    const { data } = useManagedTableV2Context<ClientLink>();
    const [cardsData, setCardsData] = useState(data);

    useEffect(() => {
        if (data?.length) {
            const augmentedData = data?.map((client) => {
                const identityManagement = findIdentityManagement({
                    entra: !!client?.provider?.find(
                        (p) =>
                            p.providerType === ProviderType.Microsoft &&
                            p.enabled
                    ),
                    gws: !!client?.provider?.find(
                        (p) =>
                            p.providerType === ProviderType.Google && p.enabled
                    )?.enabled
                });

                return {
                    ...client,
                    identityManagement
                };
            });
            setCardsData(augmentedData);
        }
    }, [data]);

    return (
        <Grid container spacing={3}>
            <Grid item xs={12} md={6} lg={3}>
                <DataAPIVisualsTotal
                    title={t('Partner.dashboard.totalClients')}
                    card
                    data={cardsData as unknown[]}
                />
            </Grid>
            <Grid item xs={12} md={6} lg={3}>
                <DataAPIVisualsSum
                    title={t('Partner.dashboard.totalActiveUsers')}
                    data={cardsData as unknown[]}
                    countVar="tenant.userCount"
                />
            </Grid>
            <Grid item xs={12} md={6} lg={3}>
                <DataAPIVisualsPieChart
                    accessorKey="identityManagement"
                    card
                    data={cardsData as unknown[]}
                    nameMap={{
                        entra: t('Common.microsoftEntraID'),
                        gws: t('Common.google_workspace'),
                        noIdentityManagement: t('Common.notConfigured')
                    }}
                    title={t('Partner.dashboard.workspaceConfigured')}
                />
            </Grid>
            <Grid item xs={12} md={6} lg={3}>
                <DataAPIVisualsPercentage
                    card
                    countVar="learningMode"
                    data={cardsData as unknown[]}
                    title={t('Clients.in_learning_mode')}
                />
            </Grid>
        </Grid>
    );
};
